import { z } from 'zod';

export const SystemUserSchema = z.object({
	name: z.string().min(1, 'Nome é obrigatório'),
	surName: z.string().min(1, 'Sobrenome é obrigatório'),
	phoneNumber: z
		.string()
		.nullish()
		.refine(v => !v || v.replace(/\D/g, '').length >= 10, 'Telefone inválido'),
	email: z.email().min(1, 'E-mail é obrigatório'),
	status: z.enum(['true', 'false'], { error: 'Status é obrigatório' }),
	planId: z.string().min(1, 'Pacote é obrigatório'),
	acceptedTerms: z.boolean().refine(v => v === true, 'Você deve aceitar os termos de uso'),
});

export const SystemUserEditSchema = z.object({
	name: z.string().min(1, 'Nome é obrigatório'),
	surName: z.string().min(1, 'Sobrenome é obrigatório'),
	phoneNumber: z
		.string()
		.nullish()
		.refine(v => !v || v.replace(/\D/g, '').length >= 10, 'Telefone inválido'),
	email: z.email().min(1, 'E-mail é obrigatório'),
	status: z.enum(['true', 'false'], { error: 'Status é obrigatório' }),
	planId: z.string().min(1, 'Pacote é obrigatório'),
});

export type SystemUserSchemaType = z.infer<typeof SystemUserSchema>;
